import {
    Collapse,
    Comment,
    Descriptions,
    Spin,
    Table,
    Modal,
    Input,
    Button,
    Affix,
    Radio,
    Form,
} from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Report } from "notiflix";

import "../styles.css";
import Footer from "../../../atoms/footer";
import Navbar from "../../../atoms/navbar";

import { requestToken } from "../../../auth/AuthServices";
import ImportantInfo from "../../../atoms/important-updates";
import { useIsAuthenticated } from "@azure/msal-react";

import HeaderFarms from "../../../utils/header_farms";
import API from "../../../services";

const ViewEpicorIR = () => {

    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    let { id } = useParams();

    const { Panel } = Collapse;

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const [loading, setLoading] = useState(true);

    const [IR, setIR] = useState(null);

    const getViewIR = (token) => {

        const epicorToken = localStorage.getItem("epicor_token");

        if (!epicorToken) return navigate("/epicor/pending");

        const headers = HeaderFarms(token);
        const fullHeaders = { ...headers, token: epicorToken };

        API.GetEpicorViewIR(fullHeaders, id)

            .then((res) => {

                const data = res;

                if (res?.data?.length === 0) return navigate("/epicor/pending");

                setIR(data);
                setLoading(false);

            })
            .catch((err) => {
                if (
                    err?.response?.status === 401 &&
                    err?.response?.data?.error === "Invalid or expired token"
                ) {
                    console.warn("Token expired atau tidak valid");
                    localStorage.removeItem("epicor_token");
                    navigate("/epicor/pending");
                } else {
                    console.error(err);
                    Report.warning(
                        "Oops.. something wrong",
                        "Sorry, this application is experiencing problems",
                        "Okay"
                    );
                }
            });
    };

    const getTotalDocExtCost = () => {
        if (!IR?.details) return 0;
        return IR.details.reduce((total, item) => {
            const cost = Number(item.Calculated_UnitCost);
            return total + (isNaN(cost) ? 0 : cost);
        }, 0);
    };

    const showModal = () => {
        setIsModalVisible(true);
        form.resetFields();
        form.setFieldsValue({
            username:
                JSON.parse(localStorage.getItem("session_farms"))?.employee_id || "",
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    function parseJwt(token) {
        const base64Url = token.split(".")[1]; // ambil payload
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        return JSON.parse(jsonPayload);
    }

    const handleOk = () => {
        form
            .validateFields()
            .then(async (values) => {

                setConfirmLoading(true);

                const accessToken = await requestToken();
                const epicorToken = localStorage.getItem("epicor_token");

                const headers = HeaderFarms(accessToken);
                const fullHeaders = { ...headers, token: epicorToken };
                try {

                    let response

                    if (values.approvalDecision === "approve") {
                        response = await API.EpicorApproveIR(fullHeaders, id, {
                            nextNote: values.nextNote,
                        });
                    } else {
                        response = await API.EpicorRejectIR(fullHeaders, id, {
                            nextNote: values.nextNote,
                        });
                    }


                    Report.success(
                        values.approvalDecision === "approve" ? "Approved" : "Rejected",
                        `IR berhasil ${values.approvalDecision === "approve" ? "disetujui" : "ditolak"
                        }`,
                        "OK"
                    );

                    setIsModalVisible(false);

                    return navigate("/epicor/pending");

                } catch (error) {

                    console.log("Error : ", error)

                    if (error.response) {
                        const status = error.response.status;
                        let message = "An error occurred. Please try again..";

                        if (status === 404) {
                            message =
                                "Data not found";
                        } else if (status === 401) {
                            message = "Password Invalid.";
                        } else if (status === 429) {
                            message =
                                "Too many attempts. Please wait 15 minutes to try again.";
                        } else {
                            message = `Request failed ${status}.`;
                        }

                        // Reset hanya field password
                        form.resetFields(["password"]);

                        // Setelah reset, kasih waktu 1 tick baru set error biar muncul
                        setTimeout(() => {
                            form.setFields([
                                {
                                    name: "password",
                                    errors: [message],
                                },
                            ]);

                            // Auto-focus biar UX-nya enak
                            document.querySelector("input[name='password']")?.focus();
                        }, 0);
                    }
                } finally {
                    setConfirmLoading(false);
                }
            })
            .catch(() => { });
    };

    const columnIRDetail = [
        {
            title: "Part Number",
            dataIndex: "Calculated_PartID",
            key: "Calculated_PartID",
        },
        {
            title: "Part Description",
            dataIndex: "Calculated_PartDescription",
            key: "Calculated_PartDescription",
        },
        {
            title: "Qty",
            dataIndex: "Calculated_RequestQty",
            key: "Calculated_RequestQty",
            render: (value) =>
                value != null ? `${Math.round(value).toLocaleString("id-ID")}` : "-",
        },
        {
            title: "Unit Cost",
            dataIndex: "Calculated_UnitCost",
            key: "Calculated_UnitCost",
            render: (value) =>
                value != null ? `${Math.round(value).toLocaleString("id-ID")}` : "-",
        },
        {
            title: "Total Cost",
            dataIndex: "Calculated_TotalCost",
            key: "Calculated_TotalCost",
            render: (value) =>
                value != null ? `${Math.round(value).toLocaleString("id-ID")}` : "-",
        },
        {
            title: "GL Account",
            dataIndex: "Calculated_GLAccountCode",
            key: "Calculated_GLAccountCode",
        },
        {
            title: "GL Account Description",
            dataIndex: "Calculated_GLAccountDescription",
            key: "Calculated_GLAccountDescription",
        },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const accessToken = await requestToken();

                if (!accessToken) {
                    
                    return;
                }

                getViewIR(accessToken);
            } catch (error) {
                console.error("❌ Gagal mengambil data:", error);
            }
        };

        fetchData();
    }, [isAuthenticated]);
    return (
        <>
            <Navbar
                title="View"
                back={true}
                subtitle="View IR"
                navigate="/epicor/pending"
            ></Navbar>
            <div className="container-fluid white-back-cr">
                <ImportantInfo></ImportantInfo>
                <div className="container mt-3 p-0" style={{ alignSelf: "center" }}>
                    <div className="row mt-1">
                        {loading && (
                            <div
                                className="fs-6 text-center mt-5"
                                style={{ color: "#B7B7B7" }}
                            >
                                <Spin size="large" />
                            </div>
                        )}
                        {IR && (
                            <>
                                <div className="col-md-12 mb-2">
                                    <Collapse defaultActiveKey={["1"]}>
                                        <Panel header={<div>Detail Information</div>} key="1">
                                            {IR ? (
                                                <>
                                                    <div className="row mt-1">
                                                        <div className="col-md-12">
                                                            <Descriptions
                                                                size="small"
                                                                bordered
                                                                title="Information"
                                                                className="mb-3"
                                                            >
                                                                <Descriptions.Item label="Issued No">
                                                                    {IR.Calculated_RequisitionNo}
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Type">
                                                                    {IR.Calculated_RequisitionType}
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                            <Descriptions size="small" bordered className="mb-4">
                                                                <Descriptions.Item
                                                                    style={{ background: "#FF9900", color: "#FFFFFF" }}
                                                                    label="Status"
                                                                >
                                                                    Waiting Approval
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <Descriptions
                                                                size="small"
                                                                bordered
                                                                className="mb-3"
                                                            >
                                                                <Descriptions.Item label="Total Order">
                                                                    {IR.Calculated_RequisitionOrder}
                                                                </Descriptions.Item>
                                                                <Descriptions.Item style={{ fontSize: "12px" }} label="Reference">
                                                                    {IR.Calculated_RequisitionReference}
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <Descriptions size="small" bordered className="mb-3">
                                                                <Descriptions.Item
                                                                    label="Requestor"
                                                                >
                                                                    {`${IR.Calculated_RequestorName} (${IR.Calculated_RequestorID})`}
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Position">
                                                                    {IR.Calculated_RequestorPosition}
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Total Cost">
                                                                    {`${Math.round(
                                                                        Number(IR.Calculated_RequisitionAmount)
                                                                    ).toLocaleString("id-ID")} ${IR.CurrencyCode || ""}`}
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                        </div>
                                                    </div>

                                                    {IR.details?.length > 0 && (
                                                        <div className="row mt-4">
                                                            <div className="col-md-12">
                                                                <h6
                                                                    style={{
                                                                        background: "#d8d8d8",
                                                                        padding: "10px",
                                                                        borderRadius: "4px",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                >
                                                                    Details Item
                                                                </h6>
                                                                <Table
                                                                    dataSource={IR.details}
                                                                    className="custom-table"
                                                                    pagination={{
                                                                        hideOnSinglePage: true,
                                                                        showLessItems: true,
                                                                    }}
                                                                    style={{ whiteSpace: "nowrap" }}
                                                                    columns={columnIRDetail}
                                                                    rowKey={(record) => record.RowIdent || record.key}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ) : null}
                                        </Panel>
                                    </Collapse>

                                </div>
                            </>
                        )}
                    </div>
                    {IR && IR.CurrDispatcherID !== "Purchasing Department" && (
                        <div className="row mb-3">
                            <div className="col-md-12 text-end">
                                <Affix offsetBottom={30}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            marginTop: 16,
                                        }}
                                    >
                                        <Button
                                            type="primary"
                                            size="middle"
                                            onClick={showModal}
                                            style={{ padding: "0 10px" }}
                                            disabled={loading}
                                        >
                                            Submit Decision
                                        </Button>
                                    </div>
                                </Affix>
                            </div>
                        </div>
                    )}
                    <Footer></Footer>
                </div>
            </div>
            <Modal
                title="Confirm Approval or Rejection"
                visible={isModalVisible}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                okText="Submit"
            >
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ approvalDecision: null, password: "", nextNote: "" }}
                >
                    <Form.Item
                        name="approvalDecision"
                        label="Decision"
                        rules={[{ required: true, message: "Select Approve or Reject" }]}
                    >
                        <Radio.Group>
                            <Radio value="approve">Approve</Radio>
                            <Radio value="reject">Reject</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        name="nextNote"
                        label="Note / Comment"
                        rules={[
                            { required: true, message: "Note is Mandatory" },
                            { whitespace: true, message: "Note is Mandatory" },
                        ]}
                    >
                        <Input.TextArea rows={4} maxLength={100} placeholder="Note" />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ViewEpicorIR;
